import { Table as AntTable, TableProps as AntTableProps } from 'antd';
import styled from 'styled-components';
import { AnyObject } from 'antd/lib/_util/type';
import { PropsWithChildren } from 'react';

type StyledTableProps = Readonly<{
	/**
     * Background color to use for the header row
     */
	headerBgColor?: string;
}>;

const rowBorderRadius = '10px';
const rowBorderSpacing = '0 10px';
const styledTableBackgroundColor = 'white';

/**
 * Styled ant table to look like card rows
 */
const StyledTable = styled(AntTable)<StyledTableProps>`
	& .${props => props.theme['@ant-prefix']}-table-middle {
		background-color: transparent;
	}
	& table {
		border-spacing: ${rowBorderSpacing};
		background-color: transparent;

		thead {
			background-color: ${props => props.headerBgColor ?? 'transparent'} !important;

			& > tr {
				& > th, & > td {
					background-color: ${props => props.headerBgColor ?? 'transparent'} !important;
					border-bottom: none !important;
				}
			}
		}

		tbody > tr {
			background-color: ${styledTableBackgroundColor};

			& > td {
				background-color: ${styledTableBackgroundColor}; 
	
				&:first-of-type {
					border-top-left-radius: ${rowBorderRadius};
					border-bottom-left-radius: ${rowBorderRadius};
				}
	
				&:last-of-type {
					border-top-right-radius: ${rowBorderRadius};
					border-bottom-right-radius: ${rowBorderRadius};
				}
			}
		}
	}
`;

function InternalTable<T extends AnyObject>(props: StyledTableProps & AntTableProps<T>) {
	return <StyledTable {...props} />;
}

type CardTableProps<T> = Pick<
	AntTableProps<T>, 'dataSource' | 'columns' | 'locale' | 'pagination' | 'loading' | 'rowKey' | 'onRow'
> & StyledTableProps;

export function CardTable<T extends AnyObject>(props: PropsWithChildren<CardTableProps<T>>) {
	const { dataSource, columns, headerBgColor, locale, pagination, children, loading, rowKey, onRow } = props;
	return (
		<InternalTable<T>
			loading={loading}
			size='middle'
			headerBgColor={headerBgColor}
			pagination={pagination}
			bordered={false}
			columns={columns}
			dataSource={dataSource}
			scroll={{
				x: 'max-content',
			}}
			locale={locale}
			rowKey={rowKey}
			onRow={onRow}
		>
			{children}
		</InternalTable>
	);
}

CardTable.Column = AntTable.Column;